<section
  class="container"
  data-cy="candidate-upload-container"
  *ngIf="{ create: create$ | async } as state"
>
  <form [formGroup]="form">
    <mat-horizontal-stepper
      [ngClass]="{ 'edit': !state.create }"
      class="legacy"
      [selectedIndex]="state.create ? 0 : 2"
      [linear]="state.create"
      #stepper
    >
      <mat-step
        [completed]="false"
        label="Basic info"
      >
        <div class="step-content">
          <h3>Basic info</h3>
          <label
            for="email"
            class="required"
          >Contact info</label>
          <input
            class="form-control mb-2"
            type="text"
            formControlName="email"
            id="email"
            data-cy="candidate-upload-container-contact-info-input"
            placeholder="Enter email here"
          />
          <mojo-candidate-source
            [form]="form"
            data-cy="candidate-upload-container-candidate-source"
          >
          </mojo-candidate-source>
        </div>
        <div class="text-center mt-5">
          <button
            matStepperNext
            data-cy="candidate-upload-container-next-step-button"
            class="btn btn-secondary"
            (click)="validateBasicInfo()"
          >Next
          </button>
          <button
            class="btn btn-link"
            (click)="close()"
          >Cancel
          </button>
        </div>
      </mat-step>
      <mat-step
        [stepControl]="form.controls.file"
        label="Upload resume"
        [completed]="false"
      >
        <div class="step-content">
          <h3>Upload resume</h3>
          <common-mojo-file-upload
            (uploaded)="form.controls.file.setValue($event)"
            text="Drop file here or"
            buttonText="select file"
          >
          </common-mojo-file-upload>
        </div>
        <div class="text-center mt-5">
          <button
            matStepperPrevious
            class="btn btn-light"
          >
            Back
          </button>
          <button
            matStepperNext
            class="btn btn-secondary"
            data-cy="candidate-upload-container-save-button"
            (click)="submit()"
          >Save
          </button>
          <button
            class="btn btn-link"
            (click)="close()"
          >Cancel
          </button>
        </div>
      </mat-step>

      <mat-step
        [completed]="false"
        label="Assigned to job"
      >
        <mojo-assign-to-job
          [candidateId]="selectedCandidateId$ | async"
          [form]="form"
          [allowIgnoreAssigning]="state.create"
          (assigned)="onAssignDone($event, state.create)"
        >
        </mojo-assign-to-job>
      </mat-step>
    </mat-horizontal-stepper>
  </form>

</section>
